export default __webpack_public_path__ + "static/media/balmain_1.504f4658.jpg";